import { Component, OnInit } from '@angular/core';
import { UserService } from "../../core/services/user.service";
import {Router} from "@angular/router";
import {Errors} from "../../core/models";
 
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
 
export class HeaderComponent implements OnInit {

  user = [];
  merchantname = [];
  username  = '';
  merchantAddressLineOne = [];
  merchantAddressLineTwo = [];
  imageurl =[];
  errors: Errors = {errors: {}};
  billing = false;
  order = false;
  finance = false;
  
  constructor( private userService: UserService,private router: Router) { }

  ngOnInit(): void { 
    this.errors = {errors: {}};
    this.userService.defineCurentuser().subscribe( 
      (data) => {   
        localStorage.setItem('merchantid',  data['content'].id );  
        localStorage.setItem('merchantuserid',  data['content'].merchant.id ); 
        localStorage.setItem('username',  data['content'].firstName );
        localStorage.setItem('userinfor',  JSON.stringify( data['content']['merchant']) ); 
        if(localStorage.getItem('userinfor')  != null){  
                 const user = localStorage.getItem('userinfor'); 
                 this.imageurl = JSON.parse(user)['imageUrl']; 
                 this.merchantname = JSON.parse(user)['merchantBusinessName']; 
                 this.username = localStorage.getItem('username');
                 this.merchantAddressLineOne = JSON.parse(user)['merchantAddressLineOne'];
                 this.merchantAddressLineTwo = JSON.parse(user)['merchantAddressLineTwo']; 
        }  
        setTimeout(() => this.userService.refreshToken().subscribe(), 5000);
        },
        (error) => {
          if(  error.error == 'invalid_token'){
            
            this.userService.purgeAuth();
            this.router.navigateByUrl('');
          }
         } 
    );

    const getUrl = this.router.url;
    
    if(getUrl == '/merchant/order'){
       this.billing = true;
    }else if(getUrl == '/merchant/order/list'){
      this.order = true;
    }else if(getUrl == '/merchant/finance/list') {
      this.finance = true;
    }else {
      this.billing = true;
    }
     
  }
   
  logout() { 
    this.userService.purgeAuth();
    this.router.navigateByUrl('/');  
  }

  
}
